<storever-loading-data *ngIf="false else dataForm"></storever-loading-data>
<ng-template #dataForm>
  <form [formGroup]="dataConfig.form" class="formHeight">
    <ul class="list-group">
      <div class="width-66">
        <storever-element-group
          [icon]="'fa-comment-alt-lines'"
          [title]="'Comments'"
          [config]="dataConfig.groupConfigs.groupConfigs[1].config"
          [form]="dataConfig.form.get(['commentsForm'])"
          [isEdit]="!(isStatusOff$|async)"
          [status]="'0'"
          [paramEdit]="{text: 'GENERIC_ADD', icon: 'fal fa-comment-plus', type: 'subscription', case: 'subscription'}"
          (save)="save(['SubscriptionEditComponent', 'commentsForm'])"
          (undo)="undo(['commentsForm'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-33">
        <storever-element-group
          [icon]="'fa-question-circle'"
          [title]="'Info'"
          [config]="dataConfig.groupConfigs.groupConfigs[0].config"
          [form]="dataConfig.form.get(['information'])"
          [isEdit]="true"
          [status]="'0'"
          [paramEdit]="{text: 'none', icon: 'none', type: 'order', case: 'none'}"
          [stylingClass]="'dynamic-form'"
        >
        </storever-element-group>
      </div>
    </ul>
  </form>
</ng-template>
<!--  <pre style="flex:1;word-break:break-word;line-height:2;">form value:{{form.value|json}}</pre>-->
<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
  <pre style="flex: 1 1 0px">commentsForm dirty{{dataConfig.form.get(['commentsForm']).dirty}}</pre>
  <pre style="flex: 1 1 0px">information dirty{{dataConfig.form.get(['information']).dirty}}</pre>
</div>

